import type { ImageAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import type { SuggestedAnswerFragment } from '../../suggested-answers/suggested-answers.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function getImageAnswer(
  answer: Pluck<SuggestedAnswerFragment, 'suggestedAnswers'> | null | undefined
) {
  return (answer?.answer as ImageAnswerFragment)?.image;
}
